import { render, staticRenderFns } from "./CarOnSale.vue?vue&type=template&id=6fed3055&"
import script from "./CarOnSale.vue?vue&type=script&lang=js&"
export * from "./CarOnSale.vue?vue&type=script&lang=js&"
import style0 from "./CarOnSale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports